import { useQueryMe } from '@api/hooks/auth/authQuery';

export function useInitial() {
  const result = useQueryMe();
  return result;
}
